export default "__VITE_ASSET__BvhYu8lm__"